import { MrgAction, MrgActionTypes, MrgState } from "./mrgTypes";

const initialState: MrgState = {
  email: "",
  name: "",
  loading: false,
};

const mrgReducer = (state = initialState, action: MrgAction) => {
  switch (action.type) {
    case MrgActionTypes.POST_EMAIL_FOR_LOGIN:
      return { ...state, email: action.payload };
    case MrgActionTypes.SET_LOADING:
      return { ...state, loading: action.payload };
    case MrgActionTypes.GET_USER_INFOR:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

export default mrgReducer;
